"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'config.tooltips.chat.pick.kdb': 'Seleziona database di conoscenza per risposte migliorate',
    'config.tooltips.chat.settings': 'Apri impostazioni chat per configurare le opzioni',
    'config.tooltips.send.prompt': 'Invia messaggio',
    'config.tooltips.prompt.with.microphone': 'Messaggio con microfono',
    'config.tooltips.attach.file.to.prompt': 'Allega file al messaggio',
    'config.tooltips.cancel.request': 'Annulla richiesta',
};
